/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { p as proxyCustomElement, H, h, d as Host } from './p-DWoUQeZ3.js';

const segmentContentCss = ":host{scroll-snap-align:center;scroll-snap-stop:always;-ms-flex-negative:0;flex-shrink:0;width:100%;min-height:1px;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none;}:host::-webkit-scrollbar{display:none}";

const SegmentContent = /*@__PURE__*/ proxyCustomElement(class SegmentContent extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '665f41a854621f898eaf7ba9a49e77cc9326501e' }, h("slot", { key: '635aa57fbf6167dcd36fe8dc5dfc1c313637ac04' })));
    }
    static get style() { return segmentContentCss; }
}, [257, "ion-segment-content"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["ion-segment-content"];
    components.forEach(tagName => { switch (tagName) {
        case "ion-segment-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SegmentContent);
            }
            break;
    } });
}

const IonSegmentContent = SegmentContent;
const defineCustomElement = defineCustomElement$1;

export { IonSegmentContent, defineCustomElement };
